import http from "./http";
import firebase from "firebase";
import config from "../config";
import RandomValues from "../utils/random";

const randomValues = new RandomValues();

export default class ContentService {

  createTopic(_form, coordinates) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("title", _form.title);
      form.append("status", "active");
      form.append("circle_id", _form.circle_id);
      form.append("profile_id", _form.profile_id);

      http.post("topic/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const topic_id = body["data"];
          form.delete("title");
          form.append("body", _form.body);
          form.append("topic_id", topic_id);

          http.post("media/create", form).then(body => {
            body = body["data"];
            if (body["code"] === 200) {
              if (coordinates) {
                const flag = {
                  type: "location",
                  value: JSON.stringify(coordinates),
                  media_id: body.data
                };
                this.addMediaFlag(flag).then(() => {
                  this.readSingleTopic(topic_id).then((topic) => {
                    this.readSinglePost(topic.first_media._id).then((post) => {
                      resolve({ topic, post });
                    }).catch(() => resolve());
                  }).catch(() => resolve());
                }).catch((err) => {
                  this.readSingleTopic(topic_id).then((topic) => {
                    this.readSinglePost(topic.first_media._id).then((post) => {
                      resolve({ topic, post });
                    }).catch(() => resolve());
                  }).catch(() => resolve());
                })
              } else {
                this.readSingleTopic(topic_id).then((topic) => {
                  this.readSinglePost(topic.first_media._id).then((post) => {
                    resolve({ topic, post });
                  }).catch(() => resolve());
                }).catch(() => resolve());
              }
            } else {
              reject(body);
            }
          }).catch((err) => reject(err));
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  updateTopic(_form) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("_id", _form.topic_id);
      form.append("title", _form.title);
      form.append("status", "active");
      form.append("circle_id", _form.circle_id);
      form.append("profile_id", _form.profile_id);

      http.post("topic/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          form.delete("title");

          form.append("_id", _form.media_id);
          form.append("status", "active");
          form.append("circle_id", _form.circle_id);
          form.append("profile_id", _form.profile_id);
          form.append("body", _form.body);
          form.append("topic_id", _form.topic_id);

          http.post("media/update", form).then(body => {
            body = body["data"];
            if (body["code"] === 200) {
              this.readSingleTopic(_form.topic_id).then((topic) => {
                this.readSinglePost(topic.first_media._id).then((post) => {
                  resolve({ topic, post });
                }).catch(() => resolve());
              }).catch(() => resolve());
            } else {
              reject(body)
            }
          }).catch((err) => reject(err));
        } else {
          reject(body)
        }
      })
    })
  }

  createTopicWithImages(_form, images, coordinates) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("title", _form.title);
      form.append("status", "active");
      form.append("circle_id", _form.circle_id);
      form.append("profile_id", _form.profile_id);

      http.post("topic/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const topic_id = body["data"];
          form.delete("title");
          form.append("body", _form.body);
          form.append("topic_id", topic_id);

          http.post("media/create", form).then(async (body) => {
            body = body["data"];
            if (body["code"] === 200) {
              const media_id = body["data"];

              if (coordinates) {
                const flag = {
                  type: "location",
                  value: JSON.stringify(coordinates),
                  media_id
                };
                try {
                  await this.addMediaFlag(flag);
                } catch (e) { }
              }

              this.uploadImages(images, media_id).then(async (imageUrls) => {
                const promises = imageUrls.map(url => {
                  return new Promise((resolve, reject) => {
                    form = new FormData();
                    form.append("title", randomValues.secureRandString());
                    form.append("path", url);
                    form.append("tag", _form.profile_id);

                    http.post("upload/create", form).then(body => {
                      body = body["data"];
                      if (body["code"] === 200) {
                        form = new FormData();
                        form.append("status", "active");
                        form.append("media_id", media_id);
                        form.append("upload_id", body["data"]);
                        form.append("profile_id", _form.profile_id);
                        http.post("media_upload/create", form).then((body) => {
                          resolve();
                        }).catch((err) => reject(err));
                      } else {
                        reject(data);
                      }
                    }).catch((err) => reject(err));
                  });
                })
                await Promise.all(promises);
                this.readSingleTopic(topic_id).then((topic) => {
                  this.readSinglePost(topic.first_media._id).then((post) => {
                    resolve({ topic, post });
                  }).catch(() => resolve());
                }).catch(() => resolve());
              }).catch((err) => reject(err));
            } else {
              reject(body);
            }
          }).catch((err) => reject(err));
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  createComment(_form) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('body', _form.body);
      form.append('status', _form.status);
      form.append('circle_id', _form.circle_id);
      form.append('topic_id', _form.topic_id);
      form.append('profile_id', _form.profile_id);

      http.post("media/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          this.readSinglePost(body.data).then((post) => resolve(post)).catch(() => resolve());
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  createCommentWithImages(_form, images) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('body', _form.body);
      form.append('status', _form.status);
      form.append('circle_id', _form.circle_id);
      form.append('topic_id', _form.topic_id);
      form.append('profile_id', _form.profile_id);

      http.post("media/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const media_id = body["data"];
          this.uploadImages(images, media_id).then(async (imageUrls) => {
            const promises = imageUrls.map(url => {
              return new Promise((resolve, reject) => {
                form = new FormData();
                form.append("title", randomValues.secureRandString());
                form.append("path", url);
                form.append("tag", _form.profile_id);

                http.post("upload/create", form).then(body => {
                  body = body["data"];
                  if (body["code"] === 200) {
                    form = new FormData();
                    form.append("status", "active");
                    form.append("media_id", media_id);
                    form.append("upload_id", body["data"]);
                    form.append("profile_id", _form.profile_id);
                    http.post("media_upload/create", form).then((body) => {
                      resolve();
                    }).catch((err) => reject(err));
                  } else {
                    reject();
                  }
                }).catch((err) => reject(err));
              });
            })
            await Promise.all(promises);
            this.readSinglePost(media_id).then((post) => resolve(post)).catch(() => resolve());
          }).catch((err) => reject(err));
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  uploadImages(images, media_id) {
    return new Promise((resolve) => {
      let downloadURLs = [];

      firebase.auth().signInWithEmailAndPassword(config.firebaseDefaultUser.email, config.firebaseDefaultUser.password)
        .then(async () => {
          const promises = images.map(image => {
            return new Promise((resolve, reject) => {
              const ref = firebase.storage()
                .ref(`/uploads/media/${media_id}/${randomValues.secureRandString()}`)
                .put(image.file);

              ref.on("state_changed", () => { }, () => reject(), () => {
                ref.snapshot.ref.getDownloadURL().then((url) => {
                  downloadURLs.push(url);
                  resolve();
                })
              })
            });
          });
          await Promise.all(promises);
          resolve(downloadURLs);
        }).catch(() => {
          resolve([]);
        })
    });
  }

  readCircleTopics(circle_id, limit, page) {
    const form = new FormData();
    form.append("circle_id", circle_id);
    form.append("limit", limit);
    form.append("page", page);

    return new Promise((resolve, reject) => {
      http.post("topic/read_by_circle", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const topics = body.data.data;
          topics.map(s => s.type = "topic");
          resolve({ content: topics, max: body.data.total });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readCirclePosts(circle_id, limit, page) {
    const form = new FormData();
    form.append("circle_id", circle_id);
    form.append("limit", limit);
    form.append("page", page);

    return new Promise((resolve, reject) => {
      http.post("media/read_by_circle", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const posts = body.data.data;
          posts.map(s => s.type = "media");
          resolve({ content: posts, max: body.data.total });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readProfileTopics(profile_id, limit, page) {
    const form = new FormData();
    form.append("profile_id", profile_id);
    form.append("limit", limit);
    form.append("page", page);

    return new Promise((resolve, reject) => {
      http.post("topic/read_by_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const topics = body.data.data;
          topics.map(s => s.type = "topic");
          resolve({ content: topics, max: body.data.total });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readProfilePosts(profile_id, limit, page) {
    const form = new FormData();
    form.append("profile_id", profile_id);
    form.append("limit", limit);
    form.append("page", page);

    return new Promise((resolve, reject) => {
      http.post("media/read_by_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const posts = body.data.data;
          posts.map(s => s.type = "media");
          resolve({ content: posts, max: body.data.total });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readSingleTopic(topic_id) {
    const form = new FormData();
    form.append("_id", topic_id);

    return new Promise((resolve, reject) => {
      http.post("topic/read", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(body.data[0]);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readSinglePost(post_id) {
    const form = new FormData();
    form.append("_id", post_id);

    return new Promise((resolve, reject) => {
      http.post("media/read", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(body.data[0]);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readTopicPosts(topic_id, limit, page) {
    const form = new FormData();
    form.append("topic_id", topic_id);
    form.append("limit", limit);
    form.append("page", page);

    return new Promise((resolve, reject) => {
      http.post("media/read_by_topic", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const posts = body.data.data;
          posts.map(s => s.type = "media");
          resolve({ content: posts, max: body.data.total });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  addMediaFlag(flag) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("type", flag.type);
      form.append("value", flag.value);
      form.append("status", "active");
      form.append("media_id", flag.media_id);

      http.post("media_flag/create", form).then(body => {
        body = body["data"];

        if (body["code"] === 200) {
          resolve(body.data);
        } else {
          reject(body)
        }
      }).catch((err) => reject(err));
    });
  }

  editMediaFlag(flag) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("type", flag.type);
      form.append("value", flag.value);
      form.append("status", "active");
      form.append("media_id", flag.media_id);
      form.append("_id", flag._id);

      http.post("media_flag/update", form).then(body => {
        body = body["data"];

        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body)
        }
      }).catch((err) => reject(err));
    });
  }

  deleteMediaFlag(id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", id);

      http.post("media_flag/delete", form).then(body => {
        body = body["data"];

        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body)
        }
      }).catch((err) => reject(err));
    });
  }

  readProfileFeed(profile_id, page, limit) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('profile_id', profile_id);
      form.append('page', page);
      form.append('limit', limit);

      http.post("media/feed", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          body.data.data.map(s => s.type = 'media');
          resolve({ content: body.data.data, max: body.data.total })
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  readTopicFeed(topic_id, page, limit) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('topic_id', topic_id);
      form.append('page', page);
      form.append('limit', limit);

      http.post("media/read_by_topic", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          body.data.data.map(s => s.type = 'media');
          resolve({ content: body.data.data, max: body.data.total })
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  createCampaign(obj) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      Object.keys(obj).map(key => form.append(key, obj[key]));
      form.delete("circles");

      http.post("campaign/create", form).then(body => {
        body = body["data"];

        if (body.code === 200) {
          const campaign_id = body.data;

          const circlePromises = obj.circles.map(circle_id => {
            return new Promise((resolve, reject) => {
              form = new FormData();
              form.append("type", "circle");
              form.append("identifier", circle_id);
              form.append("status", "active");
              form.append("campaign_id", campaign_id);

              http.post("campaign_asset/create", form).then(body => {
                body = body["data"];

                if (body.code === 200) {
                  resolve();
                } else {
                  reject(body);
                }
              }).catch((err) => reject(err));
            });
          });

          Promise.all(circlePromises).finally(() => {
            form = new FormData();
            form.append('_id', campaign_id);

            let retries = 0;

            function readCampaign() {
              http.post("campaign/read", form).then(body => {
                body = body["data"];

                if (body.code === 200) {
                  const campaign = body.data[0];

                  retries = 0;

                  function readCampaignCircles() {
                    form = new FormData();
                    form.append('campaign_id', campaign_id);
                    form.append('type', 'circle');

                    http.post("campaign_asset/read_by_campaign_type", form).then(body => {
                      body = body["data"];

                      if (body.code === 200) {
                        const campaignCircles = body.data;
                        const circles = [];

                        const circlePromises = campaignCircles.map(campaign_circle => {
                          return new Promise((resolve, reject) => {
                            form = new FormData();
                            form.append('_id', campaign_circle.identifier);

                            http.post("circle/read", form).then(body => {
                              body = body["data"];

                              if (body.code === 200) {
                                circles.push({ ...body.data[0], asset_id: campaign_circle._id });
                                resolve();
                              } else {
                                reject(body);
                              }
                            }).catch((err) => reject(err));
                          })
                        });

                        Promise.all(circlePromises).finally(() => {
                          campaign.circles = circles;
                          resolve(campaign)
                        });
                      } else {
                        resolve(campaign);
                      }
                    }).catch(err => {
                      retries += 1;

                      if (retries <= 3) {
                        readCampaignCircles();
                      } else {
                        reject(err);
                      }
                    });
                  }

                  readCampaignCircles();
                } else {
                  resolve();
                }
              }).catch(err => {
                retries += 1;
                if (retries <= 3) {
                  readCampaign();
                } else {
                  reject(err);
                }
              });
            }

            readCampaign();
          });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  readProfileCampaigns(profile_id) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('profile_id', profile_id);

      let retries = 0;

      function readCampaign() {
        http.post("campaign/read_by_profile", form).then(body => {
          body = body["data"];

          if (body.code === 200) {
            const campaigns = body.data;

            const campaignCirclesPromises1 = campaigns.map(campaign => {
              retries = 0;

              function readCampaignCircles() {
                return new Promise((resolve) => {
                  form = new FormData();
                  form.append('campaign_id', campaign._id);
                  form.append('type', 'circle');

                  http.post("campaign_asset/read_by_campaign_type", form).then(body => {
                    body = body["data"];

                    if (body.code === 200) {
                      campaign._circles = body.data;
                      resolve();
                    } else {
                      resolve();
                    }
                  }).catch(err => {
                    retries += 1;

                    if (retries <= 3) {
                      readCampaignCircles();
                    } else {
                      reject(err);
                    }
                  });
                });
              }

              readCampaignCircles();
            });

            Promise.all(campaignCirclesPromises1).then(() => {
              setTimeout(() => {
                const campaignCirclesPromises2 = campaigns.map(campaign => {
                  return new Promise((resolve) => {
                    const campaignCircles = [];

                    const promises = (campaign._circles || []).map(_circle => {
                      return new Promise((resolve, reject) => {
                        form = new FormData();
                        form.append('_id', _circle.identifier)

                        http.post("circle/read", form).then(body => {
                          body = body["data"];

                          if (body.code === 200) {
                            campaignCircles.push({ ...body.data[0], asset_id: _circle._id })
                            resolve();
                          } else {
                            reject(body);
                          }
                        }).catch((err) => reject(err));
                      });
                    });

                    Promise.all(promises).finally(() => {
                      campaign.circles = campaignCircles;
                      resolve();
                    });
                  });
                })

                Promise.all(campaignCirclesPromises2).finally(() => {
                  campaigns.map(campaign => campaign._circles = null);
                  resolve(campaigns);
                });

              }, 1000);
            }).catch(err => reject(err));
          } else {
            reject(data);
          }
        }).catch(err => {
          retries += 1;

          if (retries <= 3) {
            readCampaign();
          } else {
            reject(err);
          }
        });
      }

      readCampaign();
    });
  }

  readCircleCampaigns(circle_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('identifier', circle_id);
      form.append('type', 'circle');

      http.post('campaign_asset/read_by_type_identifier', form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(data);
        }
      }).catch(err => reject(err));
    });
  }

  editCampaign(obj) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      Object.keys(obj).map(key => form.append(key, obj[key]));
      form.delete("newCircles");
      form.delete("deletedCircles");

      http.post("campaign/update", form).then(body => {
        body = body["data"];

        if (body.code === 200) {
          const campaign_id = obj._id;

          const createCirclePromises = obj.newCircles.map(circle_id => {
            return new Promise((resolve, reject) => {
              form = new FormData();
              form.append("type", "circle");
              form.append("identifier", circle_id);
              form.append("status", "active");
              form.append("campaign_id", campaign_id);

              http.post("campaign_asset/create", form).then(body => {
                body = body["data"];

                if (body.code === 200) {
                  resolve();
                } else {
                  reject(body);
                }
              }).catch((err) => reject(err));
            });
          });

          const deleteCirclePromises = obj.deletedCircles.map(asset_id => {
            return new Promise((resolve, reject) => {
              form = new FormData();
              form.append("_id", asset_id);

              http.post("campaign_asset/delete", form).then(body => {
                body = body["data"];

                if (body.code === 200) {
                  resolve();
                } else {
                  reject(body);
                }
              }).catch((err) => reject(err));
            });
          });

          Promise.all([createCirclePromises, deleteCirclePromises]).finally(() => {
            form = new FormData();
            form.append('_id', campaign_id);

            let retries = 0;

            function readCampaign() {
              http.post("campaign/read", form).then(body => {
                body = body["data"];

                if (body.code === 200) {
                  const campaign = body.data[0];

                  retries = 0;

                  function readCampaignCircles() {
                    form = new FormData();
                    form.append('campaign_id', campaign_id);
                    form.append('type', 'circle');

                    http.post("campaign_asset/read_by_campaign_type", form).then(body => {
                      body = body["data"];

                      if (body.code === 200) {
                        const campaignCircles = body.data;
                        const circles = [];

                        const circlePromises = campaignCircles.map(campaign_circle => {
                          return new Promise((resolve, reject) => {
                            form = new FormData();
                            form.append('_id', campaign_circle.identifier);

                            http.post("circle/read", form).then(body => {
                              body = body["data"];

                              if (body.code === 200) {
                                circles.push({ ...body.data[0], asset_id: campaign_circle._id });
                                resolve();
                              } else {
                                reject(body);
                              }
                            }).catch((err) => reject(err));
                          })
                        });

                        Promise.all(circlePromises).finally(() => {
                          campaign.circles = circles;
                          resolve(campaign)
                        });
                      } else {
                        resolve(campaign);
                      }
                    }).catch(err => {
                      retries += 1;

                      if (retries <= 3) {
                        readCampaignCircles();
                      } else {
                        reject(err);
                      }
                    });
                  }

                  readCampaignCircles();
                } else {
                  resolve();
                }
              }).catch(err => {
                retries += 1;

                if (retries <= 3) {
                  readCampaign();
                } else {
                  reject(err);
                }
              });
            }

            readCampaign();
          });
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  deleteCampaign(_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('_id', _id);

      http.post("campaign/delete", form).then(body => {
        body = body["data"];

        if (body.code === 200) {
          resolve();
        } else {
          reject(data);
        }
      }).catch((err) => reject(err));
    });
  }

  sendPostAsSMS(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('recipients', obj.recipient);
      form.append('message', obj.message);

      http.post('sms/send_many', form).then(body => {
        body = body.data;

        if (body.code === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  sendPostAsEmail(obj) {
    console.log('email req obj', obj)
    let recipients = obj.recipient.split(',').map(item => item.replace(' ', '')).filter(item => item.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/))

    recipients = recipients.join()

    const form = new FormData()
    form.append('recipients', recipients)
    form.append('subject', obj.subject)
    form.append('message', obj.message)
    form.append('template', 'missive')

    return new Promise((resolve, reject) => {
      http.post('invite/send_emails', form).then(res => {
        res = res.data

        if (res.code === 200) {
          resolve()
        } else {
          // console.log(res)
          reject(res)
        }
      }).catch(err => reject(err))

    });
  }

  readProfileTimestream(profile_id, from_timestamp, to_timestamp) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('profile_id', profile_id);
      form.append('from_timestamp', from_timestamp);
      form.append('to_timestamp', to_timestamp);

      http.post("media/read_by_profile_timestream", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  readCircleAudience(circle_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('circle_id', circle_id);

      http.post("audience/read_by_circle", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  createCircleAudience(audience) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('description', audience.description);
      form.append('body', audience.body);
      form.append('type', audience.type);
      form.append('circle_id', audience.circle_id);
      form.append('profile_id', audience.profile_id);

      http.post("audience/create", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  deleteCircleAudience(_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('_id', _id);
      http.post("audience/delete", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  updateCircleAudience(audience) {
    return new Promise((resolve, reject) => {
      const form = new FormData();

      form.append('_id', audience._id);
      form.append('description', audience.description);
      form.append('body', audience.body);
      form.append('type', audience.type);
      form.append('circle_id', audience.circle_id);
      form.append('profile_id', audience.profile_id);

      http.post("audience/update", form).then(body => {
        body = body['data'];
        if (body.code === 200) {
          resolve(body)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

}
